import { useI18n } from '@i18n';
import { Stack } from '@mui/material';
import { GlobalSearchFooterItem } from './GlobalSearchFooterItem';

type ShortcutItemProps = {
  keyCombo: string;
  description: string;
};

export default function GlobalSearchFooter() {
  const { t } = useI18n();

  // Array of shortcut info
  const shortcuts: ShortcutItemProps[] = [
    { keyCombo: '↑/↓/→/←', description: t('GlobalSearch_ShortcutNavigate') },
    { keyCombo: '⏎', description: t('GlobalSearch_ShortcutSelect') },
    { keyCombo: 'Esc', description: t('GlobalSearch_ShortcutClose') },
  ];

  return (
    <Stack
      component="footer"
      direction="row"
      spacing={3}
      alignItems="center"
      sx={{
        px: 4,
        py: 3,
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        typography: 'caption',
        flexWrap: 'wrap',
        gap: 0.5,
      }}
      justifyContent={'space-between'}
    >
      {shortcuts.map((shortcut) => (
        <GlobalSearchFooterItem
          key={shortcut.keyCombo}
          keyCombo={shortcut.keyCombo}
          description={shortcut.description}
        />
      ))}
    </Stack>
  );
}
